import types from "./types";
import StoreTypes from "../../../store/types";

const initialState = {
  charity: {
    donateToCharity: false,
    charityChosen: [],
  },
  ageForInheritance: 0,
  giveOtherInheritors: {
    status: true,
    details: [],
  },
  itemRecipient: {
    specialGift: false,
    details: [],
  },
  petGuardianAllocation: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DONATION_STATUS:
      return {
        ...state,
        charity: { ...state.charity, donateToCharity: action.payload },
      };

    case types.DONATION_LIST:
      return {
        ...state,
        charity: { ...state.charity, charityChosen: action.payload },
      };

    case StoreTypes.SET_DETAILS:
      return {
        ...state,
        charity: action.payload.distribution?.charity ?? state.charity,
        ageForInheritance:
          action.payload.distribution?.ageForInheritance ??
          state.ageForInheritance,
        giveOtherInheritors:
          action.payload.distribution?.giveOtherInheritors ??
          state.giveOtherInheritors,
        itemRecipient:
          action.payload.distribution?.itemRecipient ?? state.itemRecipient,
        petGuardianAllocation:
          action.payload.distribution?.petGuardianAllocation ??
          state.petGuardianAllocation,
      };

    case types.SPECIFIC_ITEM_STATUS:
      return {
        ...state,
        itemRecipient: { ...state.itemRecipient, specialGift: action.payload },
      };

    case types.SPECIFIC_ITEMS:
      return { ...state, 
        itemRecipient: { ...state.itemRecipient, details: action.payload },
      };

    case types.ASSETS_LIST:
      return {
        ...state,
        giveOtherInheritors: { status: true, details: action.payload },
      };

    case types.ENTITLEMENT_AGE:
      return { ...state, ageForInheritance: action.payload };

    default:
      return state;
  }
};

export default reducer;
